// document.addEventListener('DOMContentLoaded', () => {
//   console.log('[marquee] DOMContentLoaded fired');
//   const valueBars = document.querySelectorAll('[data-marquee-container]');
//   console.log('[marquee] Containers encontrados:', valueBars.length);

//   valueBars.forEach((valueBar) => {
//     const valueBarContent = valueBar.querySelector('[data-marquee-content]');
//     console.log('[marquee] Encontrado content:', !!valueBarContent);
//     console.log('[marquee] InnerHTML:', valueBarContent?.innerHTML);
//     const originalHTML = valueBarContent.innerHTML;
//     let isMarqueeActive = false;
//     let lastContentWidth = 0;

//     // const initializeMarquee = () => {
//     //   // Medir el ancho original sin modificar DOM
//     //   const testDiv = document.createElement('div');
//     //   testDiv.className = 'marquee-item';
//     //   testDiv.innerHTML = originalHTML;
//     //   testDiv.style.visibility = 'hidden';
//     //   testDiv.style.position = 'absolute';
//     //   valueBarContent.appendChild(testDiv);

//     //   const contentWidth = testDiv.scrollWidth;
//     //   testDiv.remove();

//     //   // Solo aplicar marquee si el contenido es más ancho que el contenedor
//     //   if (contentWidth > valueBar.offsetWidth) {
//     //     // Si ya está activo y no cambió el ancho, no hagas nada
//     //     if (isMarqueeActive && contentWidth === lastContentWidth) return;

//     //     // Limpiar el contenido solo una vez
//     //     valueBarContent.innerHTML = '';
//     //     valueBarContent.classList.remove('marqueeValue');
//     //     valueBarContent.style.animation = '';
//     //     valueBarContent.style.removeProperty('--marquee-duration');
//     //     valueBarContent.style.removeProperty('width');

//     //     // Clonar el contenido dos veces
//     //     const first = document.createElement('div');
//     //     const second = document.createElement('div');
//     //     first.className = 'marquee-item';
//     //     second.className = 'marquee-item';
//     //     first.innerHTML = originalHTML;
//     //     second.innerHTML = originalHTML;

//     //     valueBarContent.appendChild(first);
//     //     valueBarContent.appendChild(second);

//     //     // Calcular duración
//     //     const speedPerPixel = 0.01;
//     //     const duration = contentWidth * 2 * speedPerPixel;

//     //     // Aplicar animación
//     //     valueBarContent.style.width = `${contentWidth * 2}px`;
//     //     valueBarContent.classList.add('marqueeValue');
//     //     valueBarContent.style.setProperty('--marquee-duration', `${duration}s`);

//     //     isMarqueeActive = true;
//     //     lastContentWidth = contentWidth;
//     //   } else {
//     //     // Si ya no necesita marquee y antes sí lo tenía
//     //     if (isMarqueeActive) {
//     //       valueBarContent.innerHTML = originalHTML;
//     //       valueBarContent.classList.remove('marqueeValue');
//     //       valueBarContent.style.removeProperty('--marquee-duration');
//     //       valueBarContent.style.removeProperty('width');
//     //       isMarqueeActive = false;
//     //       lastContentWidth = contentWidth;
//     //     }
//     //   }
//     // };

//     const initializeMarquee = () => {
//       console.log('[initializeMarquee] ejecutando...');
    
//       const testDiv = document.createElement('div');
//       testDiv.className = 'marquee-item';
//       testDiv.innerHTML = originalHTML;
//       testDiv.style.visibility = 'hidden';
//       testDiv.style.position = 'absolute';
//       valueBarContent.appendChild(testDiv);
    
//       const contentWidth = testDiv.scrollWidth;
//       const containerWidth = valueBar.offsetWidth;
    
//       console.log('[initializeMarquee] width del contenido:', contentWidth);
//       console.log('[initializeMarquee] width del contenedor:', containerWidth);
    
//       testDiv.remove();
    
//       if (contentWidth > containerWidth) {
//         console.log('[initializeMarquee] Activando marquee 🎉');
    
//         valueBarContent.innerHTML = '';
//         valueBarContent.classList.remove('marqueeValue');
//         valueBarContent.style.animation = '';
//         valueBarContent.style.removeProperty('--marquee-duration');
//         valueBarContent.style.removeProperty('width');
    
//         const first = document.createElement('div');
//         const second = document.createElement('div');
//         first.className = 'marquee-item';
//         second.className = 'marquee-item';
//         first.innerHTML = originalHTML;
//         second.innerHTML = originalHTML;
    
//         valueBarContent.appendChild(first);
//         valueBarContent.appendChild(second);
    
//         const speedPerPixel = 0.01;
//         const duration = contentWidth * 2 * speedPerPixel;
    
//         valueBarContent.style.width = `${contentWidth * 2}px`;
//         valueBarContent.classList.add('marqueeValue');
//         valueBarContent.style.setProperty('--marquee-duration', `${duration}s`);
    
//         isMarqueeActive = true;
//         lastContentWidth = contentWidth;
//       } else {
//         console.log('[initializeMarquee] No se necesita marquee');
//       }
//     };
    

//     // Inicializar una vez
//     initializeMarquee();

//     // Recalcular en resize solo si cambia el tamaño
//     window.addEventListener('resize', () => {
//       clearTimeout(valueBarContent._resizeTimer);
//       valueBarContent._resizeTimer = setTimeout(() => {
//         initializeMarquee();
//       }, 150);
//     });
//   });
// });


document.addEventListener('DOMContentLoaded', () => {
  // console.log('[marquee] DOMContentLoaded fired');

  const valueBars = document.querySelectorAll('[data-marquee-container]');
  // console.log('[marquee] Containers encontrados:', valueBars.length);

  valueBars.forEach((valueBar) => {
    const valueBarContent = valueBar.querySelector('[data-marquee-content]');
    // console.log('[marquee] Encontrado content:', !!valueBarContent);
    // console.log('[marquee] InnerHTML:', valueBarContent?.innerHTML);

    const originalHTML = valueBarContent.innerHTML;
    let isMarqueeActive = false;
    let lastContentWidth = 0;
    let lastContainerWidth = 0;
    const speedPerPixel = 0.01;

    const initializeMarquee = () => {
      // console.log('[initializeMarquee] ejecutando...');

      // Medir ancho del contenido
      const testDiv = document.createElement('div');
      testDiv.className = 'marquee-item';
      testDiv.innerHTML = originalHTML;
      testDiv.style.visibility = 'hidden';
      testDiv.style.position = 'absolute';
      valueBarContent.appendChild(testDiv);

      const contentWidth = testDiv.scrollWidth;
      const containerWidth = valueBar.offsetWidth;

      // console.log('[initializeMarquee] width del contenido:', contentWidth);
      // console.log('[initializeMarquee] width del contenedor:', containerWidth);

      testDiv.remove();

      const needsMarquee = contentWidth > containerWidth;

      // Si nada cambió, no reiniciar
      if (
        isMarqueeActive === needsMarquee &&
        lastContentWidth === contentWidth &&
        lastContainerWidth === containerWidth
      ) {
        // console.log('[initializeMarquee] Sin cambios, no reinicio.');
        return;
      }

      if (needsMarquee) {
        // console.log('[initializeMarquee] Activando marquee 🎉');

        valueBarContent.innerHTML = '';

        const first = document.createElement('div');
        const second = document.createElement('div');
        first.className = 'marquee-item';
        second.className = 'marquee-item';
        first.innerHTML = originalHTML;
        second.innerHTML = originalHTML;

        valueBarContent.appendChild(first);
        valueBarContent.appendChild(second);

        const duration = contentWidth * 2 * speedPerPixel;
        valueBarContent.style.width = `${contentWidth * 2}px`;

        if (!isMarqueeActive) {
          valueBarContent.classList.add('marqueeValue');
        }
        valueBarContent.style.setProperty('--marquee-duration', `${duration}s`);

        isMarqueeActive = true;
      } else {
        // console.log('[initializeMarquee] No se necesita marquee');
        if (isMarqueeActive) {
          valueBarContent.classList.remove('marqueeValue');
          valueBarContent.style.removeProperty('--marquee-duration');
          valueBarContent.style.removeProperty('width');
          valueBarContent.innerHTML = originalHTML;
          isMarqueeActive = false;
        }
      }

      lastContentWidth = contentWidth;
      lastContainerWidth = containerWidth;
    };

    // Inicializar
    initializeMarquee();

    // Recalcular en resize con debounce
    window.addEventListener('resize', () => {
      clearTimeout(valueBarContent._resizeTimer);
      valueBarContent._resizeTimer = setTimeout(initializeMarquee, 150);
    });

    // Recalcular cuando carguen las fuentes
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initializeMarquee);
    }
  });
});




